/* eslint-disable */

import {VisitStatus2} from "app/core/enum/visit-status-2.enum";

/* eslint-disable */
export const visitStatus2 = [
    {
        oid: "00000001-0000-0000-0000-000000000000",
        sort: 1,
        visit_status: VisitStatus2.FUTURE,
        tooltip: "Future - Apppointment not scheduled",
        name: VisitStatus2.FUTURE,
        code: "Fu",
        status: "future",
        icon: "davesa:visit-schedule",
        icon2: "davesa:v-schedule",
        icon3: "mat_solid:check",
        textClass: "text-slate-400",
        bgClass: "bg-slate-400",
        textClassContrast: "text-slate-100",
        bgClassContrast: "bg-slate-100",
        bgColor: "#a1a1a1",
    },
    {
        oid: "00000001-0001-0000-0000-000000000000",
        sort: 1,
        visit_status: VisitStatus2.SCHEDULED,
        tooltip: "Scheduled - Apppointment is scheduled",
        name: "Scheduled",
        code: "Sc",
        status: "scheduled",
        icon: "davesa:visit-schedule",
        icon2: "davesa:v-schedule",
        icon3: "mat_solid:check",
        textClass: "text-sky-700",
        bgClass: "bg-sky-700",
        textClassContrast: "text-slate-100",
        bgClassContrast: "bg-slate-100",
        bgColor: "#0069a8",
    },
    {
        oid: "00000002-0002-0000-0000-000000000000",
        sort: 2,
        visit_status: VisitStatus2.MISSED,
        old: "missed",
        tooltip: "Missed - Visit was skipped",
        name: "Missed",
        code: "Mi",
        status: "missed",
        icon: "davesa:visit-unconfirmed",
        icon2: "davesa:v-unconfirmed",
        icon3: "mat_solid:check",
        textClass: "text-orange-800",
        bgClass: "bg-orange-800",
        textClassContrast: "text-slate-100",
        bgClassContrast: "bg-slate-100",
        bgColor: "#9f2d00",

    },
    {
        oid: "00000003-0003-0000-0000-000000000000",
        sort: 3,
        visit_status: VisitStatus2.CLINIC,
        tooltip: "Clinic - Participant in clinic now",
        name: "Clinic",
        code: "Cl",
        status: "clinic",
        icon: "davesa:visit-confirmed",
        icon2: "davesa:v-confirmed",
        icon3: "mat_solid:check",
        textClass: "text-teal-700",
        bgClass: "bg-teal-700",
        textClassContrast: "text-slate-100",
        bgClassContrast: "bg-slate-100",
        bgColor: "#00786f",

    },
    {
        oid: "00000004-0004-0000-0000-000000000000",
        sort: 4,
        visit_status: VisitStatus2.PENDING,
        tooltip: "Pending - In review and collecting signatures",
        name: "Pending",
        code: "Pe",
        status: "pending",
        icon: "davesa:visit-reschedule",
        icon2: "davesa:v-reschedule",
        icon3: "mat_solid:check",
        textClass: "text-purple-800",
        bgClass: "bg-purple-800",
        textClassContrast: "text-slate-100",
        bgClassContrast: "bg-slate-100",
        bgColor: "#6e11b0",

    },
    {
        oid: "00000005-0005-0000-0000-000000000000",
        sort: 5,
        visit_status: VisitStatus2.SIGNED,
        tooltip: "Signed - Review done and signed",
        name: "Signed",
        code: "Si",
        status: "signed",
        icon: "davesa:visit-absent",
        icon2: "davesa:v-absent",
        icon3: "mat_solid:check",
        textClass: "text-indigo-800",
        bgClass: "bg-indigo-800",
        textClassContrast: "text-slate-100",
        bgClassContrast: "bg-slate-100",
        bgColor: "#372aac",

    },
    {
        oid: "00000006-0006-0000-0000-000000000000",
        sort: 6,
        visit_status: VisitStatus2.FILED,
        tooltip: "Filed - Visit closed and filed",
        name: "Filed",
        code: "Fi",
        status: "filed",
        icon: "davesa:visit-missed",
        icon2: "davesa:v-missed",
        icon3: "mat_solid:check",
        textClass: "text-green-800",
        bgClass: "bg-green-800",
        textClassContrast: "text-slate-100",
        bgClassContrast: "bg-slate-100",
        bgColor: "#016630",

    },
];
